import __vue_component__ from '../Button/Button.vue.js';
import SearchIcon from '../Icon/SearchIcon.js';

//
var script = {
  name: 'ImageRenderer',
  components: {
    Button: __vue_component__,
    SearchIcon
  },
  props: {
    url: {
      type: String,
      default: undefined
    },
    height: {
      type: [Number, String],
      default: 24
    },
    width: {
      type: [Number, String],
      default: 24
    },
    showActions: {
      type: Boolean,
      default: false
    },
    zoomable: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    placeholderSize() {
      const height = +this.height || Number.POSITIVE_INFINITY;
      const width = +this.width || Number.POSITIVE_INFINITY;
      const size = Math.min(width, height) || 100;
      return size;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/ImageRenderer.vue_rollup-plugin-vue=script.js